angular.module('CarsSaraBo').controller('CompanyRequestController', ['$scope', 'CompanyRequestService','$http', '$rootScope','AlfredService','$filter', 'LoadingWheelService', 'NotificationService',
    function($scope, companyRequestService,$http, $rootScope,alfredService,$filter, loadingWheelService, notificationService) {

        $scope.initialize = function() {
            loadingWheelService.show();
            $scope.config = {
                itemsPerPage:10,
                currentPage:1,
                numPages:0,
                totalItems:0
            }
            $scope.loadCompany();
            $scope.pageCompanyRequestList = [];
            $scope.pageCompanyRequestFilterList = [];
            $scope.companyRequestDetail=undefined;
            $scope.order = {field : "" , desc : false};
            $scope.search={};
            $scope.showDetailsModal=false;
        }

         $scope.sort = function(fieldName, desc){
            if($scope.order.field != fieldName){
                $scope.order.field = fieldName;
                $scope.order.desc = desc != undefined ? desc : false;
            } else {
                $scope.order.desc = desc != undefined ? desc : !$scope.order.desc;
            }
            if(!(fieldName=='date')){
                $scope.pageCompanyRequestFilterList = $filter('orderBy')($scope.pageCompanyRequestFilterList, $scope.order.field, $scope.order.desc);
            }else{
                var order = $scope.order.desc?-1:1;
                $scope.pageCompanyRequestFilterList.sort(function compare(a,b) {
                    if ($scope.orderByDate(a.date) < $scope.orderByDate(b.date))
                        return order;
                    if ($scope.orderByDate(a.date) > $scope.orderByDate(b.date))
                        return order*-1;
                    return 0;
                });
            }

            $scope.goToFirstPage();
        }

        $scope.getDomain = function(){
            return document.domain;
        }

        $scope.isNotFromCoClPe = function(){
            return (window.location.toLocaleString().indexOf("www.despegar.com.co") == -1)
                && (window.location.toLocaleString().indexOf("cars.despegar.it.co") == -1)
                && (window.location.toLocaleString().indexOf("www.despegar.cl") == -1)
                && (window.location.toLocaleString().indexOf("www.despegar.com.pe") == -1)
                && (window.location.toLocaleString().indexOf("cars.despegar.it.pe") == -1);
        }

        $scope.orderByDate = function(dateString){
            var parts = dateString.split('/');
            var date = new Date(parseInt(parts[2]),
                parseInt(parts[1]),
                parseInt(parts[0]));

            return date.getTime();
        }

        $scope.goToFirstPage = function (){
            $scope.config.currentPage = 1;
            $scope.changePage();
            loadingWheelService.hide();
        }

        $scope.loadNewModel = function(){
            $rootScope.sidebarVisible = false;
            $http.get("../rest/geo/countries").then(function(response) {
                $scope.countries = response;
            });
        }

        $scope.getDate = function(date){
            var fullDate = new Date(date);
            var hoursMinutesSeconds = $scope.getNoSingleValueDate(fullDate.getHours()) + ":" + $scope.getNoSingleValueDate(fullDate.getMinutes()) + ":" + $scope.getNoSingleValueDate(fullDate.getSeconds());
            return $scope.getNoSingleValueDate(fullDate.getDate()) + "/" + $scope.getNoSingleValueDate(fullDate.getMonth()+1) + "/" + fullDate.getFullYear().toString() + " " +  hoursMinutesSeconds;
        }

        $scope.getNoSingleValueDate= function(dateFunction){
            return (dateFunction>9)?dateFunction.toString():'0'+dateFunction.toString();
        }

        $scope.save = function(){
            if($scope.companyRequest.$valid){
                $http.post('../rest/companyRequest', $scope.companyNewRequest).
                then(function(response) {
                    $scope.showConfirmationMessage=true;
                });
            }else{
                $scope.errorField={};
                for(i in $scope.companyRequest.$error.required){
                    $scope.errorField[$scope.companyRequest.$error.required[i].$name]="error";
                }
            }
            $scope.notifyFormErrors($scope.companyRequest.$error);
        }

        $scope.softDelete = function (companyRequest) {
            $scope.showModal('MARK_COMPANY_REQUEST_AS_SOLVED_TITLE', 'MARK_COMPANY_REQUEST_AS_SOLVED_MESSAGE', function () {
                companyRequestService.remove({oid: companyRequest.oid})
                .$promise
                .then(function (response) {
                    notificationService.displayToast('companyRequest.toast.MARK_COMPANY_REQUEST_AS_SOLVED_TITLE', 'companyRequest.toast.MARK_COMPANY_REQUEST_AS_SOLVED_MESSAGE', {'name': companyRequest.name});
                    $scope.initialize();
                },
                function (error) {
                    console.log(error);
                });
            });
        };

        $scope.view = function(oid){
            var obj=_.find($scope.companyRequestFullList, {oid: oid});
            $scope.companyRequestDetail=obj;
            $scope.showDetailsModal = true;
        }

        $scope.closeDetailModal = function(){
          $scope.showDetailsModal = false;
        }

        $scope.loadCompany = function(){
            companyRequestService.query(function(response) {
                $scope.companyRequestFullList = response;
                $scope.companyRequestList = $scope.getTableList($scope.companyRequestFullList);
                $scope.config.totalItems = $scope.companyRequestList.length;
                $scope.config.numPages=Math.floor($scope.companyRequestList.length/$scope.config.itemsPerPage);
                $scope.pageCompanyRequestFilterList=$scope.companyRequestList;
                $scope.changePage();
                $scope.hideProgressBar();
            });
        }

        $scope.getTableList = function(list){
            var listWithTableFields = [];
            angular.forEach(list, function (item) {
                listWithTableFields.push({oid:item.oid,name:item.name,city:item.city,country:item.country,date:$scope.getDate(item.date)});
            });
            return listWithTableFields;
        }

        $scope.filterBy = function(value) {
            loadingWheelService.show();
            $scope.pageCompanyRequestFilterList = $filter('filter')($scope.companyRequestList, {$:value}, false);
            $scope.config.totalItems = $scope.pageCompanyRequestFilterList.length;
            $scope.config.numPages=Math.floor($scope.pageCompanyRequestFilterList.length/$scope.config.itemsPerPage);
            $scope.goToFirstPage();
        }

        $scope.changePage = function(){
            var startItem = $scope.config.itemsPerPage*$scope.config.currentPage;
            $scope.pageCompanyRequestList = $scope.pageCompanyRequestFilterList.slice(startItem-$scope.config.itemsPerPage, startItem);
        }

        $scope.getCountryData = function() {
            $scope.companyNewRequest.country = $scope.countrySelection.descriptions.es;
            $scope.companyNewRequest.countryIataCode = $scope.countrySelection.code;
        }

        $scope.getLogoLink = function(){
            var logoEn="http://us.staticontent.com/nibbler-versioned/1.5.29/Nibbler/Header/img/best-price-en.svg";
            var logoEs="http://us.staticontent.com/nibbler-versioned/1.5.29/Nibbler/Header/img/best-price-es.svg";
            if((window.location.toLocaleString().indexOf("www.us.despegar.com") == -1)
                && (window.location.toLocaleString().indexOf("cars.us.despegar.it") == -1)){
                return logoEs;
            }else{
                return logoEn;
            }
        }

        $scope.isLoading = function () {
            return loadingWheelService.isLoading();
        }

        $scope.initialize();
    }]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/companyRequest_controller.js
// module id = 898
// module chunks = 3